import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  toggle(event) {
    const isChecked = !!event.target.checked
    this.contentTarget.classList.toggle("hidden", isChecked)
    this.contentTarget
      .querySelectorAll("input, select, textarea, button")
      .forEach((el) => { el.disabled = isChecked })
  }
}
